(() => {
  function init(root) {
    if (root.dataset.navigationReady) return;
    const nav = root.querySelector('.rh-benefits__nav');
    const previous = root.querySelector('[data-benefit-previous]');
    const next = root.querySelector('[data-benefit-next]');
    if (!nav || !previous || !next) return;
    root.dataset.navigationReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const update = () => {
      previous.disabled = nav.scrollLeft <= 2;
      next.disabled = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
    };
    const move = direction => nav.scrollBy({left: direction * nav.clientWidth * .72, behavior: reduced.matches ? 'instant' : 'smooth'});
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    nav.addEventListener('scroll', update, {passive: true});
    nav.addEventListener('click', event => {
      const tab = event.target.closest('[role="tab"]');
      if (!tab) return;
      const rect = tab.getBoundingClientRect();
      const bounds = nav.getBoundingClientRect();
      const delta = rect.left < bounds.left ? rect.left - bounds.left : rect.right > bounds.right ? rect.right - bounds.right : 0;
      if (delta) nav.scrollBy({left: delta, behavior: reduced.matches ? 'instant' : 'smooth'});
    });
    nav.addEventListener('keydown', event => {
      const tabs = [...nav.querySelectorAll('[role="tab"]')];
      const index = tabs.indexOf(event.target);
      if (index < 0 || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[target].focus({preventScroll: true});
      tabs[target].click();
    });
    new ResizeObserver(update).observe(nav);
    update();
  }
  document.querySelectorAll('.rh-benefits--scroll-mobile').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.rh-benefits--scroll-mobile').forEach(init));
})();
